@use '../../../../design-tokens/border-radius/border-radius' as *;
@use '../../../../design-tokens/typography/typography' as *;

@layer design-system {
  .legendContainer {
    display: flex;
    gap: 16px;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    padding: 20px 0;
  }

  .legendContainerMultipleRows {
    align-items: stretch;
    flex-direction: column;
  }

  .legendItem {
    display: flex;
    align-items: center;
    color: var(--text-default);
    @include typography-v2-body-xs;
  }

  .legendColor {
    width: 8px;
    height: 8px;
    margin-right: 8px;
    border-radius: border-radius(full);
  }

  .multiRowWrapper {
    display: flex;
    gap: 20px;
    justify-content: center;
  }
}
